import { Tooltip, IconButton, TableCell } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Link } from 'react-router-dom';

function EdaTableViewButton(props) {
	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title="View">
				<IconButton component={Link} to={`/eda/view/${props.item.id}`} disabled={props.item.status !== 'DONE'}>
					<SearchIcon fontSize="small" />
				</IconButton>
			</Tooltip>
		</TableCell>
	);
}

export default EdaTableViewButton;
